/**
 * W17 — 代码自动补全
 *
 * 提供两类补全：
 *  1. 内置函数/关键字词表（硬编码）
 *  2. 工作区变量（运行时动态，通过 refreshVarCompletions() 更新）
 *
 * session_id 直接从 sessionStorage 读取，避免与 ws.js 循环依赖。
 */

import { autocompletion } from '@codemirror/autocomplete';

// ── 内置函数 / 关键字词表 ─────────────────────────────────────────────────────
export const BUILTINS = [
  // 数学
  'abs','acos','acosh','asin','asinh','atan','atan2','atanh',
  'ceil','cos','cosh','exp','floor','log','log2','log10',
  'mod','rem','round','sign','sin','sinh','sqrt','tan','tanh',
  // 矩阵构造
  'zeros','ones','eye','rand','randn','linspace','logspace','magic',
  // 矩阵属性
  'size','length','numel','ndims','isempty','isvector','ismatrix','isscalar',
  // 统计 / 归约
  'min','max','sum','prod','cumsum','cumprod','diff',
  'mean','var','std','median','sort','unique',
  'find','any','all',
  // 线性代数
  'inv','det','eig','svd','lu','qr','chol','rank',
  'norm','trace','diag','triu','tril','cross','dot',
  // 多项式
  'polyfit','polyval','polyder','polyint','roots','poly',
  // 数值方法
  'fzero','fminbnd','fminsearch','integral',
  'ode45','interp1','interp2',
  // 信号处理
  'fft','ifft','fft2','fftshift',
  // 绘图
  'plot','plot3','surf','mesh','meshgrid','contour','contourf',
  'bar','barh','pie','stem','stairs','errorbar',
  'imagesc','colormap','polarplot',
  'xlabel','ylabel','zlabel','title','legend','grid','hold',
  'subplot','figure','gcf','gca','close','saveas',
  'semilogx','semilogy','loglog','text',
  // 输出
  'disp','fprintf','sprintf','printf',
  // 字符串
  'num2str','str2num','str2double','int2str',
  'strsplit','strjoin','strtrim','upper','lower',
  'contains','startsWith','endsWith','regexp','regexprep',
  // 文件 I/O
  'fopen','fclose','fread','fwrite','fscanf',
  'csvread','csvwrite','textscan',
  // 系统
  'exist','dir','pwd','cd','system','input',
  // 杂项
  'eval','feval','tic','toc','assert','class','isa',
  // 常量
  'true','false','pi','inf','Inf','nan','NaN','eps',
  // 控制流关键字
  'for','while','if','elseif','else','end','break','continue',
  'return','function','switch','case','otherwise',
].map(label => ({ label, type: 'function' }));

// ── 工作区变量缓存 ────────────────────────────────────────────────────────────
let cachedVars = [];

/**
 * 从后端 /api/session/{id}/vars 刷新变量补全缓存。
 * 由 main.js 在 ty:done 事件后调用。
 */
export async function refreshVarCompletions() {
  const sessionId = sessionStorage.getItem('ty_session_id');
  if (!sessionId) return;
  try {
    const res  = await fetch(`/api/session/${sessionId}/vars`);
    const json = await res.json();
    cachedVars = (json.vars || []).map(label => ({ label, type: 'variable' }));
  } catch {
    // 网络异常时保留旧缓存
  }
}

/** 仅供测试使用：直接设置变量缓存。 */
export function _setCachedVars(vars) {
  cachedVars = vars.map(label => ({ label, type: 'variable' }));
}

// ── CodeMirror 补全源 ─────────────────────────────────────────────────────────
function tianyuanCompletion(context) {
  const word = context.matchBefore(/\w*/);
  if (!word || (word.from === word.to && !context.explicit)) return null;

  const options = [...BUILTINS, ...cachedVars].filter(
    item => item.label.startsWith(word.text)
  );

  return {
    from:     word.from,
    options,
    validFor: /^\w*$/,
  };
}

export const tianyuanAutocomplete = autocompletion({
  override: [tianyuanCompletion],
});
